export const defaultPagination = {
  page: 1, perPage: 10,
};
